// import qs from "qs";
import request from "@/utils/requestSC";

// 查询签收单详情
export async function queryReplaceUploadVoucherByOrderId(params) {
  return request.get("/rest/order/queryReplaceUploadVoucherByOrderId", {
    params
  });
}

// 确认收货
export async function upVoucherUrlByShipper(params) {
  return request.post("/rest/order/upVoucherUrlByShipper", params);
}
